<template>
    <div class="page-sign-todo">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">加盟</div>
            <div class="breadcrumb-item">加盟收集列表</div>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <Table ref="table"
                   size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共 {{totalCount}} 條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
	let isthis;
    export default {
        data()
        {
            return {
                pageIndex: 1,
                curPageSize: 10,
                totalCount: 1,
                pageInput: '',
                pickAddress: [],
                pickShelves: [],
                isSubmiting: false,
                isSubmitingLog: false,
                isShowModalSign: false,
                serial_number_single: '',

                form: {
                    uid:'',
                    paytype:'',
                    serial_number: '',
                    created_at: ''
                },
                table: {
                    column: [
                        {
                            title: '電話',
                            key: 'phone',
                            align: 'center',
                            minWidth: 150,
                            sortable: true
                        },
                        {
                            title: '地址',
                            key: 'text',
                            align: 'center',
                            minWidth: 150,
                            sortable: true
                        },
                        {
                            title: '填寫時間',
                            key: 'created_at',
                            align: 'center',
                            minWidth: 150,
                            sortable: true
                        },
                        {
                            title: '備註',
                            key: 'remark',
                            align: 'center',
                            minWidth: 150,
                            sortable: true
                        },
                    ],
                    data: []
                },
            };
        },
        mounted()
        {
			this.getList();
        },
        methods: {
            getList(){
                let form = this.form;
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.franchiseList,
                    method: 'get'
                }).then((res) =>
                {
                    this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        for (let i = 0; i < resData.length; i++)
                        {
                            tempArr.push({
                                id: resData[i].id,
                                phone: resData[i].phone,
                                created_at: resData[i].created_at,
                                remark: resData[i].remark == null ? '- - -' : resData[i].remark,
                                text: resData[i].text,
                            });
                        }
                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    } else {
                        this.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },

            handleSearch(){
                this.pageIndex = 1;
                this.getList();
            },

            handlePageSizeChange(value){
                this.pageIndex = 1;
                this.getList();
            },

            handlePageInput(){
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.floor(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },

            handlePageEnter(){
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
				this.getList();
            },

            handlePageChange(value){
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'franchiseList.scss';
</style>